import r from "./arrow-tooltip.js";
import e from "./button.js";
import m from "./checkbox.js";
import g, { hues as i } from "./clrs.js";
import n from "./input.js";
import f from "./layout.js";
import p from "./tab.js";
import u from "./text.js";
import x from "./text-button.js";
import { getZIndexConfig as C } from "./z-index.js";
const d = () => {
  const t = f(), { gutter: o } = t;
  return {
    arrowTooltip: r(),
    button: e(o),
    colors: g(),
    hues: i,
    input: n(o),
    checkbox: m(o),
    layout: t,
    tab: p(t.gutter),
    text: u(),
    textButton: x(),
    zIndex: C()
  };
};
export {
  d as getTheme
};
//# sourceMappingURL=get-theme.js.map
